import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import "../../../../styles/common/tableChart.module.css";
import {
  formatNumberCommaSeparated,
  truncateNumber,
} from "../../../../utils/common";

// Sample Data Array
const data = [
  {
    name: "From Location - To Location",
    co2: "2,50,33,638",
    share: "29.18%",
    // flag: "https://upload.wikimedia.org/wikipedia/commons/2/2c/India-flag-a4.jpg",
  },
  {
    name: "From Location - To Location",
    co2: "2,50,33,638",
    share: "29.18%",
    // flag: "https://dm0qx8t0i9gc9.cloudfront.net/thumbnails/video/GTYSdDW/chinese-flag_bygsrmyls_thumbnail-1080_01.png",
  },
  {
    name: "From Location - To Location",
    co2: "2,50,33,638",
    share: "29.18%",
    // flag: "https://th.bing.com/th/id/OIP.qIVO5VLgIP2clXu2hCJ08QHaE1?w=267&h=180&c=7&r=0&o=5&dpr=1.5&pid=1.7",
  },
  {
    name: "From Location - To Location",
    co2: "2,50,33,638",
    share: "29.18%",
    // flag: "https://th.bing.com/th?id=OIP.uW9Hi1USsULyX2e4Y7iy-gHaE7&w=306&h=204&c=8&rs=1&qlt=90&o=6&dpr=1.5&pid=3.1&rm=2",
  },
  {
    name: "From Location - To Location",
    co2: "1,23,45,678",
    share: "14.50%",
    // flag: "https://upload.wikimedia.org/wikipedia/commons/0/05/Flag_of_Brazil.svg",
  },
  {
    name: "From Location - To Location",
    co2: "98,76,543",
    share: "11.87%",
    // flag: "https://upload.wikimedia.org/wikipedia/en/b/ba/Flag_of_Germany.svg",
  },
  {
    name: "From Location - To Location",
    co2: "87,65,432",
    share: "10.56%",
    // flag: "https://upload.wikimedia.org/wikipedia/en/9/9e/Flag_of_Japan.svg",
  },
  {
    name: "From Location - To Location",
    co2: "75,43,210",
    share: "9.08%",
    // flag: "https://upload.wikimedia.org/wikipedia/commons/b/b9/Flag_of_Australia.svg",
  },
  {
    name: "From Location - To Location",
    co2: "65,43,210",
    share: "7.87%",
    // flag: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Flag_of_Canada_%28Pantone%29.svg",
  },
  {
    name: "From Location - To Location",
    co2: "54,32,109",
    share: "6.78%",
    // flag: "https://upload.wikimedia.org/wikipedia/en/a/ae/Flag_of_the_United_Kingdom.svg",
  },
];

const CustomSelect = styled(Select)(({ theme }) => ({
  height: "auto",
  "& .MuiSelect-select": {
    padding: "8px 12px",
    height: "auto",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: "4px",
  },
}));

const EmittingTableChart = ({ tableData }) => {
  const [startIndex, setStartIndex] = useState(0);
  const visibleCountries = 4;
  console.log("firse", tableData);
  const handleUpClick = () => {
    if (startIndex > 0) {
      setStartIndex((prevIndex) => prevIndex - 1);
    }
  };

  const handleDownClick = () => {
    if (startIndex < data.length - visibleCountries) {
      setStartIndex((prevIndex) => prevIndex + 1);
    }
  };

  return (
    <>
      <TableContainer>
        <Table style={{ marginTop: "0.5rem" }}>
          <TableHead>
            <TableRow>
              <TableCell style={{ padding: "8px", width: "60%" }}>
                <span style={{ fontWeight: "600", fontSize: "14px" }}>
                  Route Name
                </span>
                <span
                  style={{
                    display: "inline-flex",
                    flexDirection: "column",
                    marginLeft: "8px",
                    verticalAlign: "middle",
                  }}
                >
                  <i
                    className="bi bi-caret-up-fill"
                    onClick={handleUpClick}
                    style={{
                      lineHeight: "1",
                      margin: "0",
                      padding: "0",
                      fontSize: "12px",
                      color: "grey",
                      cursor: "pointer",
                    }}
                  ></i>
                  <i
                    className="bi bi-caret-down-fill"
                    onClick={handleDownClick}
                    style={{
                      lineHeight: "1",
                      margin: "-4px 0 0 0",
                      padding: "0",
                      fontSize: "12px",
                      color: "grey",
                      cursor: "pointer",
                    }}
                  ></i>
                </span>
              </TableCell>
              <TableCell style={{ padding: "8px" }}>
                <span style={{ fontWeight: "600", fontSize: "14px" }}>
                  CO2 emission (tonnes)
                </span>
                <span
                  style={{
                    display: "inline-flex",
                    flexDirection: "column",
                    marginLeft: "8px",
                    verticalAlign: "middle",
                  }}
                >
                  <i
                    className="bi bi-caret-up-fill"
                    onClick={handleUpClick}
                    style={{
                      lineHeight: "1",
                      margin: "0",
                      padding: "0",
                      fontSize: "12px",
                      color: "grey",
                      cursor: "pointer",
                    }}
                  ></i>
                  <i
                    className="bi bi-caret-down-fill"
                    onClick={handleDownClick}
                    style={{
                      lineHeight: "1",
                      margin: "-4px 0 0 0",
                      padding: "0",
                      fontSize: "12px",
                      color: "grey",
                      cursor: "pointer",
                    }}
                  ></i>
                </span>
              </TableCell>
              <TableCell style={{ padding: "8px" }}>
                <span style={{ fontWeight: "600", fontSize: "14px" }}>
                  Share of World (%)
                </span>
                <span
                  style={{
                    display: "inline-flex",
                    flexDirection: "column",
                    marginLeft: "8px",
                    verticalAlign: "middle",
                  }}
                >
                  <i
                    className="bi bi-caret-up-fill"
                    onClick={handleUpClick}
                    style={{
                      lineHeight: "1",
                      margin: "0",
                      padding: "0",
                      fontSize: "12px",
                      color: "grey",
                      cursor: "pointer",
                    }}
                  ></i>
                  <i
                    className="bi bi-caret-down-fill"
                    onClick={handleDownClick}
                    style={{
                      lineHeight: "1",
                      margin: "-4px 0 0 0",
                      padding: "0",
                      fontSize: "12px",
                      color: "grey",
                      cursor: "pointer",
                    }}
                  ></i>
                </span>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData && tableData?.length > 0 ? (
              tableData.map((country, index) => (
                <TableRow key={index}>
                  <TableCell
                    style={{
                      color: "rgba(28, 72, 107, 1)",
                      fontFamily: "Inter",
                      fontWeight: "600",
                      fontSize: "14px",
                    }}
                  >
                    {/* <img
                      src={country.flag}
                      alt={`${country.name} Flag`}
                      className="flag-icon"
                    />{" "} */}
                    From {country?.origin} - To {country?.destination}
                  </TableCell>
                  <TableCell
                    style={{
                      color: "rgba(0, 0, 0, 1)",
                      fontFamily: "Inter",
                      fontWeight: "400",
                      fontSize: "14px",
                    }}
                  >
                    {formatNumberCommaSeparated(
                      (Number(country.totalEmission) || 0).toFixed(3)
                    )}
                  </TableCell>
                  <TableCell
                    style={{
                      color: "rgba(0, 0, 0, 1)",
                      fontFamily: "Inter",
                      fontWeight: "400",
                      fontSize: "14px",
                    }}
                  >
                    {truncateNumber(country?.percentage ?? 0, 2)}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow sx={{ width: "100%" }}>
                <TableCell
                  colSpan={3}
                  sx={{
                    textAlign: "center",
                    color: "#d3d3d3",
                    fontWeight: "bold",
                    m: "8%",
                    fontSize: "20px",
                    fontFamily:"inter",
                    height:"5rem"
                  }}
                >
                  No Data Found
                </TableCell>
                {/* <NoDataFound /> */}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default EmittingTableChart;
